import {makeStyles} from "tss-react/mui";

export const useGeneratedDocumentChipStyles = makeStyles()((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  icon: {
    width: 30,
    height: 30,
  },
  textContainer: {
    overflow: "hidden",
  },
  fileName: {
    fontWeight: 500,
    lineHeight: 1.2,
    marginBottom: "0px !important",
  },
  fileSize: {
    lineHeight: 1.2,
  },
  downloadButton: {
    marginLeft: theme.spacing(0.5),
  },
}));
